import { BaseEntity } from "yt-ng-framework";

export class UserRole extends BaseEntity{
    constructor(){
        super();
    }
    Name : string = null;

    Deserialize(input: any){
        this.ID=input.ID;
        this.Name=input.Name;
        return this;
    }

    Serialize(input: UserRole){
        return input;
    }
}